<tlk-text-input
	[label]="label"
	[required]="required"
	[ngModel]="displayValue"
	(ngModelChange)="onInput($event)"
	(blur)="onBlur()"
	[errorStateMatcher]="dobErrorMatcher"
	[placeholder]="placeholder"
	[isDisabled]="disabled"
	name="dateOfBirth">
	<span tlk-error>{{ translationPrefix + '.DobError' | translate: { format: placeholder } }}</span>
</tlk-text-input>
